// import { take, call, put, select } from 'redux-saga/effects';

import { all, call, spawn, takeEvery, put } from 'redux-saga/effects';
import { toast } from '@cashfree-intl/coherent';
import {
  UPDATE_USER_ON_PRODUCT_FRUIT,
  GET_WHITELISTING_DATA,
  GET_PAYMENT_GROUPS_DATA,
  GET_MERCHANT_PROFILE_DATA,
  GET_INSTALLED_APPS_DATA
} from './constants';
import request from 'utils/request';
import { GET_WHITELISTING_DATA_URL, GET_PAYMENT_METHODS_DATA_URL, GET_SHOPIFY_MERCHANT, DELETE_PRODUCT_FRUIT_CAMPAIGNS } from 'constants/url';
import { disableLoaderAction, enableLoaderAction } from './actions';


/**
 * Saga to remove user from unleash after completing the flow
 *
 * @param {Object} action - The action containing call back to component.
 * @param {Object} action.payload - The payload.
 * @param {string} action.payload.cb - The call abck.
 * */

export function* updateUserOnProductFruit(actions) {
  try {
    const { cb,campaign } = actions.payload;
    const {url,method}= DELETE_PRODUCT_FRUIT_CAMPAIGNS
    const dayZeroUserUrl =`${url}/${campaign}/complete`
    const response = yield call(request, dayZeroUserUrl, { method });

    if (response.statusCode === 200) {
      cb(response);
    }
  } catch (err) {
    const errorMessage = err?.errorMeta?.message || 'Something went wrong';
    toast.error(errorMessage);
  }
}

export function* fetchWhitelistingData({ data: { successCb, errorCb } } :  any) {
  try {
    const { url, method } = GET_WHITELISTING_DATA_URL;
    const response = yield call(request, url, {
      method,
      useBasePath: true,
    });

    if (successCb) {
      successCb(response);
    }

    return response;
  } catch (err) {
    if (errorCb) errorCb();
    toast.error('Unable to fetch the data, Please try again later!');
  }
}

export function* fetchPaymentGroupsData({ data: { successCb, errorCb } } : any) {
  try {
    const { url, method } = GET_PAYMENT_METHODS_DATA_URL;
    const finalUrl = `${url}?currency=INR&amount=10`;
    const response = yield call(request, finalUrl, {method});

    if (successCb) {
      successCb(response);
    }
    return response;
  } catch (err) {
    if (errorCb) errorCb();
    toast.error('Unable to fetch the data, Please try again later!');
  }
}


export function* fetchInstalledAppsData({ data: { successCb, errorCb } } :  any) {
  try {
    const { url, method } = GET_SHOPIFY_MERCHANT;
    yield put(enableLoaderAction());
    const response = yield call(request, url, {
      method,
    });
    if (successCb) {
      successCb(response);
    }
  } catch (err) {
    if (errorCb) errorCb();
    toast.error('Unable to fetch the data, Please try again later!');
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* fetchMerchantData({ data: { data, successCb, errorCb } } : any) {
  try {
     yield put(enableLoaderAction());

    const [whitelistingResult, paymentGroupsResult] = yield all([
      call(fetchWhitelistingData, { data: { successCb, errorCb } }),
      call(fetchPaymentGroupsData, { data: { successCb, errorCb } }),
    ]);

    if (successCb) {
      successCb({ whitelistingResult, paymentGroupsResult });
    }
    
  } catch (error) {
    toast.error('Unable to fetch the data. Please try again later.');
    if (errorCb) {
      errorCb(error);
    }
  } finally {
    yield put(disableLoaderAction());
  }
}


export function* updateUserOnProductFruitSaga() {
  yield takeEvery(UPDATE_USER_ON_PRODUCT_FRUIT, updateUserOnProductFruit);
}

export function* fetchWhitelistingSaga() {
  yield takeEvery(GET_WHITELISTING_DATA, fetchWhitelistingData);
}

export function* fetchPaymentGroupsSaga() {
  yield takeEvery(GET_PAYMENT_GROUPS_DATA, fetchPaymentGroupsData);
}

export function* fetchInstalledAppsSaga() {
  yield takeEvery(GET_INSTALLED_APPS_DATA, fetchInstalledAppsData);
}

export function* fetchMerchantDataSaga() {
  yield takeEvery(GET_MERCHANT_PROFILE_DATA, fetchMerchantData);
}

export default function* productTourSaga() {
  const sagas = [ updateUserOnProductFruitSaga, fetchWhitelistingSaga, fetchPaymentGroupsSaga, fetchMerchantDataSaga, fetchInstalledAppsSaga];

  yield all(
    sagas.map((saga) =>
      // eslint-disable-next-line func-names
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e); // Log any errors
          }
        }
      })
    )
  );
}
